import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { getMarkupStatusColor } from "@pages/project-details/project-markups/status/markup-status-utils";
import { useMemo } from "react";
/** Renders the icon status icon of corresponding color */
export function MarkupStatusIcon(t0) {
  const $ = _c(10);
  const {
    status,
    shouldHaveBorder: t1
  } = t0;
  const shouldHaveBorder = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== status) {
    t2 = getMarkupStatusColor(status);
    $[0] = status;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const markupStatusColor = t2;
  const t3 = shouldHaveBorder ? `1px solid ${markupStatusColor.iconBorder}` : "none";
  let t4;
  if ($[2] !== markupStatusColor.iconBackground || $[3] !== t3) {
    t4 = {
      height: "24px",
      width: "24px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: t3,
      backgroundColor: markupStatusColor.iconBackground
    };
    $[2] = markupStatusColor.iconBackground;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== markupStatusColor.icon) {
    t5 = <Box sx={{
      width: "0.5rem",
      height: "0.5rem",
      borderRadius: "0.25rem",
      backgroundColor: markupStatusColor.icon
    }} />;
    $[5] = markupStatusColor.icon;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Box component="div" sx={t4}>{t5}</Box>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}